import { render, staticRenderFns } from "./AdminRoot.vue?vue&type=template&id=5ba2a4bb&"
import script from "./AdminRoot.vue?vue&type=script&lang=js&"
export * from "./AdminRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports